import { useState, useEffect } from "react";
import { createUseStyles } from "react-jss";

import Input from "./Input";
import TextArea from "./TextArea";
import Lightbox from "./Lightbox";
import Checkbox from "./Checkbox";
import Button from "./Button";
import Selector from "./Selector";

const getOptions = (type, images) => {
  const options = [];
  let key = 1;

  if (type !== "pinned-video") {
    options.push({
      type: "input",
      placeholder: "Text for tooltip",
      label: "Tooltip",
      name: "tooltip",
      key: `option-${key++}`,
    });
    if (type !== "poi") {
      options.push({
        type: "checkbox",
        name: "permaTooltip",
        label: "Make permanently visible",
        key: `option-${key++}`,
      });
    }
  }

  switch (type) {
    case "note":
      options.push(
        {
          type: "input",
          placeholder: "Title of popup",
          label: "Title",
          name: "title",
          key: `option-${key++}`,
        },
        {
          type: "input",
          placeholder: "Image URL",
          label: "Image URL (optional)",
          name: "image",
          key: `option-${key++}`,
        },
        {
          type: "input",
          placeholder: "URL",
          label: "Audio URL (optional)",
          name: "audio",
          key: `option-${key++}`,
        },
        {
          type: "textarea",
          placeholder: "Content of popup",
          label: "Content",
          name: "content",
          key: `option-${key++}`,
        },
      );
      break;
    case "gallery":
      options.push(
        {
          type: "input",
          placeholder: "Title of popup",
          label: "Title",
          name: "title",
          key: `option-${key++}`,
        },
        {
          type: "gallery",
          label: "Content",
          name: "content",
          key: `option-${key++}`,
        },
      );
      break;
    case "video":
      options.push(
        {
          type: "input",
          placeholder: "Title of popup",
          label: "Title",
          name: "title",
          key: `option-${key++}`,
        },
        {
          type: "select",
          name: "video_type",
          label: "Video Type",
          options: [
            {
              label: "MP4 Video",
              value: "mp4",
            },
            {
              label: "Youtube Video",
              value: "youtube",
            },
            {
              label: "Vimeo Video",
              value: "vimeo",
            },
          ],
          key: `option-${key++}`,
        },
        {
          type: "input",
          placeholder: "URL",
          label: "Video URL",
          name: "url",
          key: `option-${key++}`,
        },
      );
      break;
    case "audio":
      options.push(
        {
          type: "input",
          placeholder: "Title of popup",
          label: "Title",
          name: "title",
          key: `option-${key++}`,
        },
        {
          type: "select",
          name: "audio_type",
          label: "Audio Type",
          options: [
            {
              label: "MP3 audio",
              value: "mp3",
            },
          ],
          key: `option-${key++}`,
        },
        {
          type: "input",
          placeholder: "URL",
          label: "Audio URL",
          name: "url",
          key: `option-${key++}`,
        },
        {
          type: "textarea",
          placeholder: "Content of popup",
          label: "Transcript (optional)",
          name: "content",
          key: `option-${key++}`,
        },
      );
      break;
    case "pinned-video":
      options.push({
        type: "input",
        placeholder: "Video URL or IFRAME",
        label: "Video URL/Iframe",
        name: "url",
        key: `option-${key++}`,
      });
      break;
    case "web":
      options.push(
        {
          type: "input",
          placeholder: "URL of web page",
          label: "URL",
          name: "url",
          key: `option-${key++}`,
        },
        {
          type: "select",
          name: "display",
          label: "Display Options",
          options: [
            {
              label: "New Tab",
              value: "tab",
            },
            {
              label: "Lightbox",
              value: "lightbox",
            },
          ],
          key: `option-${key++}`,
        },
      );
      break;
    case "link":
      options.push(
        {
          type: "select",
          name: "id",
          label: "Image",
          options: Object.keys(images).map(key => ({
            label: images[key].name,
            value: key,
          })),
          key: `option-${key++}`,
        },
        {
          type: "checkbox",
          name: "checkbox",
          label: "Add boomerang",
          key: `option-${key++}`,
        },
      );
      break;
    case "fade":
      options.push(
        {
          type: "select",
          name: "id",
          label: "Image",
          options: Object.keys(images).map(key => ({
            label: images[key].name,
            value: key,
          })),
          key: `option-${key++}`,
        },
        {
          type: "checkbox",
          name: "checkbox",
          label: "Add boomerang",
          key: `option-${key++}`,
        },
      );
      break;
    case "elevate-down":
      options.push(
        {
          type: "select",
          name: "id",
          label: "Image",
          options: Object.keys(images).map(key => ({
            label: images[key].name,
            value: key,
          })),
          key: `option-${key++}`,
        },
        {
          type: "checkbox",
          name: "checkbox",
          label: "Add boomerang",
          key: `option-${key++}`,
        },
      );
      break;
    case "elevate-up":
      options.push(
        {
          type: "select",
          name: "id",
          label: "Image",
          options: Object.keys(images).map(key => ({
            label: images[key].name,
            value: key,
          })),
          key: `option-${key++}`,
        },
        {
          type: "checkbox",
          name: "checkbox",
          label: "Add boomerang",
          key: `option-${key++}`,
        },
      );
      break;
    case "poi":
      options.push(
        {
          type: "input",
          placeholder: "Name",
          label: "Name of Point of Interest",
          name: "name",
          key: `option-${key++}`,
        },
        {
          type: "checkbox",
          name: "onEnter",
          label: "Look at automatically when entering scene",
          key: `option-${key++}`,
        },
      );
      break;
    case "timeline":
      options.push(
        {
          type: "input",
          placeholder: "Title of popup",
          label: "Title",
          name: "title",
          key: `option-${key++}`,
        },
        {
          type: "timeline",
          label: "Scenes",
          name: "scenes",
          key: `option-${key++}`,
          options: Object.keys(images).map(key => ({
            label: images[key].name,
            value: key,
          })),
        },
      );
      break;
    default:
      break;
  }

  return options;
};

export const InputField = ({
  placeholder,
  label,
  value = "",
  onChange,
  name,
  classes,
  formattingMethod,
}) => (
  <div className={classes.row}>
    <label htmlFor={name}>{label}</label>
    <Input
      name={name}
      onChange={value => {
        onChange(value);
      }}
      value={value}
      placeholder={placeholder}
      formattingMethod={formattingMethod}
    />
  </div>
);

export const TextAreaField = ({
  placeholder,
  label,
  value = "",
  onChange,
  name,
  classes,
}) => (
  <div className={classes.row}>
    <label htmlFor={name}>{label}</label>
    <TextArea
      name={name}
      onChange={value => {
        onChange(value);
      }}
      value={value}
      placeholder={placeholder}
    />
  </div>
);

export const SelectField = ({
  label,
  name,
  value,
  options,
  onChange,
  classes,
  expanded,
  toggle,
}) => {
  useEffect(() => {
    if (value === undefined) {
      onChange(options[0].value);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [onChange, value, options[0].value]);

  if (value === undefined) {
    return null;
  }

  return (
    <div className={classes.row}>
      <label htmlFor={name}>{label}</label>
      <div className={classes.selectorContainer}>
        <Selector
          name={name}
          onChange={onChange}
          value={value}
          options={options}
          noLeftMargin
          light
          expanded={expanded}
          toggle={toggle}
          span
        />
      </div>
    </div>
  );
};

export const GalleryPicker = ({ value = [""], name, classes, onChange }) => {
  const [images, setImages] = useState(value);

  useEffect(() => {
    onChange(images.filter(Boolean));
  }, [images, onChange]);

  return (
    <div className={classes.row}>
      <label htmlFor={name}>Gallery picker</label>
      {images.map((image, index) => (
        <div className={classes.galleryRow}>
          <Input
            key={index}
            name={name}
            onChange={value =>
              setImages(imgs => {
                const arr = Array.from(imgs);
                arr[index] = value;
                return arr;
              })
            }
            value={image}
            placeholder="Image URL"
            formattingMethod={true}
          />
          <button
            className={classes.galleryX}
            onClick={() =>
              setImages(imgs => imgs.filter((_, i) => i !== index))
            }
          >
            +
          </button>
        </div>
      ))}
      <button
        className={classes.button}
        onClick={() => setImages(i => [...i, ""])}
      >
        + Add
      </button>
    </div>
  );
};

const IndependantSelector = props => {
  const [expanded, setExpanded] = useState(false);
  return (
    <Selector
      expanded={expanded}
      toggle={() => setExpanded(x => !x)}
      noLeftMargin
      light
      span
      {...props}
    />
  );
};

export const TimelinePicker = ({
  scenes = [],
  images = [],
  name,
  classes,
  onChange,
}) => {
  return (
    <div className={classes.row}>
      <label htmlFor={name}>Timeline</label>
      {scenes.map(({ id, scene, name }, index) => (
        <div key={id}>
          <button
            className={classes.delete}
            onClick={() => {
              const arr = Array.from(scenes);
              delete arr[index];
              onChange(arr.filter(Boolean));
            }}
          >
            +
          </button>
          <div className={classes.selectorContainer}>
            <IndependantSelector
              value={scene}
              options={images}
              onChange={value => {
                const arr = Array.from(scenes);
                arr[index].scene = value;
                onChange(arr);
              }}
            />
          </div>
          <Input
            name={name}
            onChange={value => {
              const arr = Array.from(scenes);
              arr[index].name = value;
              onChange(arr);
            }}
            value={name}
            placeholder="Scene label"
            formattingMethod={true}
          />
        </div>
      ))}
      <button
        className={classes.button}
        onClick={() => {
          if (images.length > 0) {
            const scene = images[0];
            onChange([
              ...scenes,
              { id: Date.now(), name: "", scene: scene.value },
            ]);
          }
        }}
      >
        + Add
      </button>
    </div>
  );
};

export const useHotspotLightboxStyles = createUseStyles({
  row: {
    width: "100%",
    display: "flex",
    "flex-direction": "column",
    "align-items": "center",
    "& *": {
      width: "100%",
      boxSizing: "border-box",
    },
  },
  container: {
    width: "100%",
  },
  selectorContainer: {
    position: "relative",
    margin: "10px 0",
    width: "100%",
    height: 36,
    display: "flex",
  },
  button: {
    border: "none",
    background: "unset",
    color: "white",
    cursor: "pointer",
  },
  delete: {
    extend: "button",
    transform: "rotate(45deg)",
    width: "auto",
    position: "relative",
    left: "calc(100% - 25px)",
    "font-size": 20,
  },
  galleryRow: { display: "flex" },
  galleryX: {
    "flex-grow": 0,
    width: 20,
    height: 20,
    transform: "rotate(45deg)",
    background: "none",
    border: "none",
    color: "white",
    margin: [0, 20],
    position: "relative",
    top: 15,
    "font-size": 20,
    cursor: "pointer",
    padding: 0,
  },
});

const HotspotOptionsLightbox = ({
  show,
  hotspot,
  target,
  getOnChangeHandler,
  onComplete,
  onClose,
  images,
  isBoomerang: isBoomerangProp,
  isNodeLink,
}) => {
  const classes = useHotspotLightboxStyles();
  const [expanded, setExpanded] = useState();

  const toggleMenu = () => setExpanded(x => !x);

  if (hotspot === null) {
    return null;
  }

  const isBoomerang = hotspot.type !== "poi" && isBoomerangProp;

  return (
    <Lightbox show={show} onClose={onClose}>
      <h3>{hotspot.type === "pinned-video" ? "Video" : "Hotspot"} Options</h3>
      {show &&
        getOptions(hotspot.type, images).map(item => {
          if (item.type === "input") {
            let formattingMethod = false;
            if (item.name === "tooltip" || item.name === "title") {
              formattingMethod = true;
            }
            let tooltipLabel = item.label;
            if (isBoomerang) {
              tooltipLabel = `Target ${tooltipLabel}`;
            }
            return (
              <div className={classes.container} key={item.key}>
                <InputField
                  placeholder={item.placeholder}
                  name={item.name + item.placeholder}
                  label={tooltipLabel}
                  value={
                    hotspot[item.name]
                      ? hotspot[item.name]
                      : hotspot.options[item.name]
                  }
                  onChange={getOnChangeHandler(item.name)}
                  classes={classes}
                  formattingMethod={formattingMethod}
                />
                {isNodeLink && isBoomerang && (
                  <InputField
                    placeholder={item.placeholder}
                    name={item.name}
                    label={`Source ${item.label} (as viewed from target)`}
                    value={target}
                    onChange={getOnChangeHandler("target")}
                    classes={classes}
                    formattingMethod={formattingMethod}
                  />
                )}
              </div>
            );
          } else if (item.type === "gallery") {
            return (
              <GalleryPicker
                key={item.key}
                classes={classes}
                onChange={getOnChangeHandler(item.name)}
                name={item.name}
                value={hotspot.options.content}
              />
            );
          } else if (item.type === "timeline") {
            return (
              <TimelinePicker
                key={item.key}
                classes={classes}
                onChange={getOnChangeHandler(item.name)}
                name={item.name}
                scenes={hotspot.options.scenes}
                images={item.options}
              />
            );
          } else if (item.type === "textarea") {
            return (
              <TextAreaField
                key={item.key}
                placeholder={item.placeholder}
                name={item.name}
                label={item.label}
                value={
                  hotspot[item.name]
                    ? hotspot[item.name]
                    : hotspot.options[item.name]
                }
                onChange={getOnChangeHandler(item.name)}
                classes={classes}
              />
            );
          } else if (isNodeLink === undefined) {
            if (item.type === "select") {
              return (
                <SelectField
                  key={item.key}
                  name={item.name + item.placeholder}
                  label={item.label}
                  options={item.options}
                  value={
                    hotspot[item.name]
                      ? hotspot[item.name]
                      : hotspot.options[item.name]
                  }
                  onChange={getOnChangeHandler(item.name)}
                  classes={classes}
                  expanded={expanded}
                  toggle={toggleMenu}
                />
              );
            } else if (item.type === "checkbox") {
              return (
                <div key={item.key}>
                  <Checkbox
                    name={item.name}
                    value={
                      (item.name === "checkbox"
                        ? isBoomerang
                        : hotspot[item.name]
                        ? hotspot[item.name]
                        : hotspot.options[item.name]) ?? false
                    }
                    label={item.label}
                    className={classes}
                    onChange={getOnChangeHandler(item.name)}
                  />
                  {isBoomerang && item.name === "checkbox" && (
                    <>
                      <hr />
                      <InputField
                        placeholder={item.placeholder}
                        name={item.name}
                        label="Source Tooltip (viewed from Target image)"
                        value={target}
                        onChange={getOnChangeHandler("target")}
                        classes={classes}
                        formattingMethod={true}
                      />
                    </>
                  )}
                </div>
              );
            } else {
              return null;
            }
          } else {
            return null;
          }
        })}
      <Button onClick={onComplete}>Save</Button>
    </Lightbox>
  );
};

export default HotspotOptionsLightbox;
